export const tipoImovelID =
{
    Uniresidencial: "Uniresidencial",
    MultiresidencialAte4Pav: "MultiresidencialAte4Pav",
    MultiresidencialAcima4Pav: "MultiresidencialAcima4Pav",
    NaoResidencial: "NaoResidencial",
    CondominioLotes: "CondominioLotes",
    ERB: "ERB",
    GLP: "GLP",
    Loteamento: "Loteamento"
  }

export const tipoImovelNome =
{
    Uniresidencial: "Uniresidencial",
    MultiresidencialAte4Pav: "Multiresidencial até 4 pavimentos",
    MultiresidencialAcima4Pav: "Multiresidencial acima de 4 pavimentos",
    NaoResidencial: "Não residencial / misto",
    GalpaoDepositoIndustria: "Galpão / Depósito / Indústria",
    CondominioLotes: "Condomínio de lotes",
    ERB: "ERB",
    GLP: "GLP",
    Loteamento: "Loteamento"
}

export const tipoImovelIDFromNome =
{
    "Uniresidencial": "Uniresidencial",
    "Multiresidencial até 4 pavimentos": "MultiresidencialAte4Pav",
    "Multiresidencial acima de 4 pavimentos": "MultiresidencialAcima4Pav",
    "Não residencial / misto": "NaoResidencial",
    "Galpão / Depósito / Indústria": "NaoResidencial",
    "Condomínio de lotes": "CondominioLotes",
    "ERB": "Especial",
    "GLP": "Especial",
    "Loteamento": "Loteamento"
}

export const tipoImovelSiglasLegado =
{
    "Uniresidencial": "UNIRES",
    "Multiresidencial até 4 pavimentos": "MULTI_RES_ATE_4_PAV",
    "Multiresidencial acima de 4 pavimentos": "MULTI_RES_ACIMA_4_PAV",
    "Não residencial / misto": "COMERC_MISTO",
    "Galpão / Depósito / Indústria": "GALP_DEP_IND",
    "Condomínio de lotes": "COND_LOTES_N_COMERCIAL",
    "Condomínio de lotes comercial": "COND_LOTES_COMERCIAL",
    "ERB": "ERB",
    "GLP": "GLP",
    "Loteamento": "LOTEAMENTO"
}